// src/components/Loading.js

import React from "react";
import Maestras from "../../static/Maestras.gif";

const Loading = () => {
  return (
    <div className="text-center">
      <img
        src={Maestras}
        alt="Cargando..."
        style={{ width: "200px", height: "200px" }}
      />
    </div>
  );
};

export default Loading;
